import { z } from 'zod'

export const userCreateSchema = z.object({
  username: z.string().trim().min(3, 'user.validation.usernameMin'),
  password: z.string().min(8, 'user.validation.passwordMin'),
  fullName: z.string().trim().optional(),
  email: z.string().trim().email('common.invalidEmail').or(z.literal('')).optional(),
  phone: z.string().trim().optional(),
  avatarUrl: z.string().trim().url('common.invalidUrl').or(z.literal('')).optional(),
})

export const userUpdateSchema = z.object({
  username: z.string(),
  fullName: z.string().trim().optional(),
  email: z.string().trim().email('common.invalidEmail').or(z.literal('')).optional(),
  phone: z.string().trim().optional(),
  avatarUrl: z.string().trim().url('common.invalidUrl').or(z.literal('')).optional(),
})

export type UserCreateValues = z.infer<typeof userCreateSchema>
export type UserUpdateValues = z.infer<typeof userUpdateSchema>
